var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-loading"},[_c('div',{staticClass:"feedback-loading__content"},[_c('div',{staticClass:"text-base-100"},[_vm._v("\n      "+_vm._s(_vm.$i18nPresenter.t("Just a moment! Generating your quiz..."))+"\n    ")]),_c('FakeProgressbar',{attrs:{"resetProgressBar":_vm.resetProgressBar}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }